import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class default_1 extends Vue {
    @Prop()
    title;
}
